/* eslint-disable prettier/prettier */
import PropTypes from "prop-types";
import React, { useState } from "react";

import UserSelectListPage from "../../../../../containers/administrative/usuarios/user-select-list-page";
import { language } from "../../../../../language";
import Provider from "../../../../../Provider";
import GenericModal from "../../../../modal-closebtn/index";

const ModelerModalUserList = ({ FormComponents, theme, saveUser, element }) => {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = (value) => {
    const saveObject = {};
    if (value && value.length > 0) {
      value.forEach(function (element) {
        saveObject[element] = true;
      });
    }

    saveUser(element, Object.keys(saveObject).length > 0 ? saveObject : false);
  };

  const onchangeUserSelect = (value) => {
    handleSave([...value.ids]);
  };

  return (
    <Provider>
      <GenericModal
        title={language.userList}
        handleClose={handleClose}
        size="xl"
        open={open}
        bigHeight
      >
        <UserSelectListPage
          onchangeUserSelect={onchangeUserSelect}
          selectedusers={FormComponents}
        />
      </GenericModal>
    </Provider>
  );
};

ModelerModalUserList.propTypes = {
  FormComponents: PropTypes.any,
  theme: PropTypes.object,
  saveUser: PropTypes.func,
  element: PropTypes.object,
};

export default ModelerModalUserList;
